module.exports = __webpack_public_path__ + "img/Beta_unterricht.f9efb82d.svg";